export const formatPriceWithCurrency = (price: number, currency: string) => {
  if (currency === 'KRW' || currency === '') return price.toLocaleString() + '원';
  return new Intl.NumberFormat('ko', {
    style: 'currency',
    currency: currency,
  }).format(price);
}